import { render, staticRenderFns } from "./AudioMediaControl.vue?vue&type=template&id=84af296e&scoped=true"
import script from "./AudioMediaControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioMediaControl.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AudioMediaControl.vue?vue&type=style&index=0&id=84af296e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84af296e",
  null
  
)

export default component.exports